import React from 'react';
import { injectIntl } from 'react-intl-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import messages from '@atlaskit/editor-common/messages';
import { Avatars } from './avatars';
import { InviteToEditButton } from './invite-to-edit';
var AvatarsWithPluginState = function AvatarsWithPluginState(props) {
  var title = props.intl.formatMessage(messages.inviteToEditButtonTitle);
  var selected = props.isInviteToEditButtonSelected,
    onClick = props.inviteToEditHandler,
    Component = props.inviteToEditComponent,
    editorView = props.editorView,
    featureFlags = props.featureFlags,
    editorAnalyticsAPI = props.editorAnalyticsAPI,
    editorAPI = props.editorAPI;
  var _useSharedPluginState = useSharedPluginState(editorAPI, ['collabEdit']),
    collabEditState = _useSharedPluginState.collabEditState;
  if (!collabEditState) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Avatars, {
    sessionId: collabEditState.sessionId,
    participants: collabEditState.activeParticipants,
    editorView: editorView,
    featureFlags: featureFlags,
    editorAnalyticsAPI: editorAnalyticsAPI,
    editorAPI: editorAPI
  }, /*#__PURE__*/React.createElement(InviteToEditButton, {
    title: title,
    selected: selected,
    onClick: onClick,
    Component: Component
  }));
};
export default injectIntl(AvatarsWithPluginState);